module.exports = __webpack_public_path__ + "ddaa2fe7142d8a5d39eadb60fddedbad.png";